import React, { useContext, useState } from 'react';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import 'react-slidedown/lib/slidedown.css';
import { useIntersectionObserver } from 'usehooks-ts';
import {
  RecallCardContentContainer,
  RecallCardHeaderContainer,
  RecallCardWrapper,
  RecallCardHeader,
  RecallSubtextWrapper,
  RecallHeaderContainer,
  AlertHeader,
  NoOpenRecallWrapper,
  HR,
  RecallIconWrapper,
  RecallSubtext,
  RecallTitle,
} from './RecallCard.styles';
import { RecallHeader } from '../_common/recall/Recall';
import RecallIcon from '../../assets/RecallIcon';
import WarningIcon from '../../assets/WarningIcon';
import { AnalyticEvents } from '../../constants';

const RecallCard = ({ feedData, positionValue }: any) => {
  const { trackEvent } = useContext(AnalyticsContext) as any;
  const [cardPosition] = useState(positionValue || 0);
  const { id: cardId, title, callToAction, content } = feedData;

  let recallSubText =
    'Don`t worry, recalls are common! Your local [make] dealership will help you get right back on the road.';

  const hasOpenRecalls = content.recallInfo.recalls?.length > 0;

  if (hasOpenRecalls) {
    recallSubText = recallSubText.replace('[make]', content.recallInfo.make || content.recallInfo.recalls[0].make);
  }

  const captureImpression = () => {
    setTimeout(() => {
      trackEvent(AnalyticEvents.viewedOvpCardImpression, {
        cardId,
        cardPosition,
        recallCount: [content.recallInfo.recalls.length],
      });
      datadogRum.addAction(AnalyticEvents.viewedOvpCardImpression, {
        cardId,
        cardPosition,
        recallCount: [content.recallInfo.recalls.length],
      });
    }, 1000);
  };
  const { ref } = useIntersectionObserver({
    freezeOnceVisible: true,
    threshold: 0.5,
    onChange: (isIntersecting) => {
      if (isIntersecting && captureImpression) captureImpression();
    },
  });

  return (
    <RecallCardWrapper ref={ref}>
      {hasOpenRecalls && (
        <AlertHeader>
          <WarningIcon />
          <span data-testid="recalls-card-alert-text">
            {content.recallInfo.recalls?.length >= 2
              ? `${content.recallInfo.recalls.length} Open Recalls Found`
              : `1 Open Recall Found`}
          </span>
        </AlertHeader>
      )}
      <RecallCardHeaderContainer>
        <RecallIconWrapper data-testid="recalls-card-title-icon">
          <RecallIcon />
        </RecallIconWrapper>
        <RecallCardHeader data-testid="recalls-card-title">{title}</RecallCardHeader>
      </RecallCardHeaderContainer>
      <RecallCardContentContainer>
        {hasOpenRecalls ? (
          <RecallHeaderContainer>
            {content.recallInfo.recalls.map((recall: any) => (
              <React.Fragment key={recall.oemId}>
                <RecallHeader
                  recall={recall}
                  cardId={cardId}
                  cardPosition={cardPosition}
                  callToAction={callToAction}
                  hasOpenRecalls={hasOpenRecalls}
                  recallCount={content.recallInfo.recalls.length}
                />
                <HR />
              </React.Fragment>
            ))}
          </RecallHeaderContainer>
        ) : (
          <NoOpenRecallWrapper>
            <RecallTitle data-testid="no-open-recall-body-text">No Open Recalls Found</RecallTitle>
          </NoOpenRecallWrapper>
        )}
      </RecallCardContentContainer>
      {hasOpenRecalls && (
        <RecallSubtextWrapper>
          <RecallSubtext data-testid="recalls-card-subtext">{recallSubText}</RecallSubtext>
        </RecallSubtextWrapper>
      )}
    </RecallCardWrapper>
  );
};

export default RecallCard;
